export default class ShiftTasksApi {
  constructor({ httpGet, httpPost, httpPut, httpDelete }) {
    this.httpGet = httpGet;
    this.httpPost = httpPost;
    this.httpPut = httpPut;
    this.httpDelete = httpDelete;
  }

  getTaskTemplates(params, httpConfig) {
    return this.httpGet('shifts/tasks/templates', params, httpConfig);
  }

  createTaskTemplate(taskTemplate, params, httpConfig) {
    return this.httpPost('shifts/tasks/templates', taskTemplate, params, httpConfig);
  }

  editTaskTemplate(taskTemplate, params, httpConfig) {
    return this.httpPut(
      `shifts/tasks/templates/${taskTemplate.id}`,
      taskTemplate,
      params,
      httpConfig
    );
  }

  deleteTaskTemplate(taskTemplateId, params, httpConfig) {
    return this.httpDelete(`shifts/tasks/templates/${taskTemplateId}`, params, httpConfig);
  }

  getTaskInstances(params, httpConfig) {
    return this.httpGet('shifts/tasks/instances', params, httpConfig);
  }

  getTaskInstanceDetails(taskInstanceId, params, httpConfig) {
    return this.httpGet(`shifts/tasks/instances/${taskInstanceId}`, params, httpConfig);
  }

  editTaskInstance(taskInstance, params, httpConfig) {
    return this.httpPut(
      `shifts/tasks/instances/${taskInstance.id}`,
      taskInstance,
      params,
      httpConfig
    );
  }

  deleteTaskInstance(taskInstanceId, params, httpConfig) {
    return this.httpDelete(`shifts/tasks/instances/${taskInstanceId}`, params, httpConfig);
  }

  updateTaskInstanceStatus(taskInstanceId, status, params, httpConfig) {
    return this.httpPut(
      `shifts/tasks/instances/${taskInstanceId}/status`,
      { status },
      params,
      httpConfig
    );
  }

  updateTaskInstanceSubtaskStatus(subtaskId, status, params, httpConfig) {
    return this.httpPut(
      `shifts/tasks/subtasks/${subtaskId}/status`,
      { status },
      params,
      httpConfig
    );
  }
}
